exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".BriefingsPanel__root___TjqkL {\n}\n.BriefingsPanel__row___3uRHG {\n  border-bottom: 1px solid #ddd;\n  padding: 10px 0;\n}\n.BriefingsPanel__row___3uRHG:last-of-type {\n  border-bottom: 0 none;\n}\n", ""]);
// Exports
exports.locals = {
	"root": "BriefingsPanel__root___TjqkL",
	"row": "BriefingsPanel__row___3uRHG"
};